<!--
 * @Author: 蓝欣 10884240+lan-xin-x@user.noreply.gitee.com
 * @Date: 2025-03-18 20:19:53
 * @LastEditors: 蓝欣 10884240+lan-xin-x@user.noreply.gitee.com
 * @LastEditTime: 2025-03-28 20:18:02
 * @FilePath: \my-car\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <router-view></router-view>
</template>

<script setup>
import { onMounted } from 'vue';
const setRootFontSize = () => {
  const screenWidth = document.documentElement.clientWidth
  console.log(screenWidth, 'screenWidthscreenWidth');

  const fontSize = screenWidth / 192
  console.log(fontSize, 'fontSizefontSize');
  document.documentElement.style.fontSize = `${fontSize}px`
};
const debounce = (fn, delay = 300) => {
  let timer = null
  return function () {
    timer && clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, arguments), delay)
  }
};
// 监听窗口变化（带防抖）
window.addEventListener('resize', debounce(setRootFontSize))

// 监听设备方向变化（针对移动端）
window.addEventListener('orientationchange', debounce(setRootFontSize))
onMounted(() => {
  setRootFontSize();
});
</script>

<style scoped lang="scss"></style>
